import { TicketRepository } from '../repositories/TicketRepository'

export function ListPatientTicketDateCase(ticketRepository: TicketRepository) {
  return async function ({ patientId }: { patientId: string }) {
    return await ticketRepository.listPatientTicketDate({ patientId })
  }
}
